module.exports = __webpack_public_path__ + "img/123mail.fdd87226.png";